"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusWithin = exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
var useActiveElement = function useActiveElement() {
  var _document;
  var _useState = (0, _react.useState)(typeof document !== 'undefined' && ((_document = document) === null || _document === void 0 ? void 0 : _document.activeElement)),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    activeElement = _useState2[0],
    setActiveElement = _useState2[1];
  (0, _react.useEffect)(function () {
    var unMounted = false;
    var onDocumentBlur = function onDocumentBlur(event) {
      if (event.relatedTarget !== null || unMounted) {
        return;
      }
      setActiveElement(document.activeElement);
    };
    var onDocumentFocus = function onDocumentFocus() {
      if (unMounted) {
        return;
      }
      setActiveElement(document.activeElement);
    };
    document.addEventListener('blur', onDocumentBlur, true);
    document.addEventListener('focus', onDocumentFocus, true);
    return function () {
      unMounted = true;
      document.removeEventListener('blur', onDocumentBlur);
      document.removeEventListener('focus', onDocumentFocus);
    };
  }, []);
  return activeElement;
};
var useFocusWithin = exports.useFocusWithin = function useFocusWithin(_ref) {
  var targetElement = _ref.targetElement;
  var activeElement = useActiveElement();
  return {
    isFocused: targetElement && activeElement ? targetElement.contains(activeElement) : false
  };
};
var _default = exports.default = useFocusWithin;